<template>
  <template v-if="formConfig?.fields">
    <mpf-form
      :form-title="formConfig.config?.formTitle"
      :hint="formConfig.config?.hint"
      :fields="populatedForm?.fields"
      @submit="(e) => handleSubmit(e)"
      submit-label="Continue"
    />
  </template>
</template>

<script setup lang="ts">
  import { useRouteMeta } from '../composables/useRouteMeta';
  import MpfForm from '../components/MpfForm/MpfForm.vue';
  import { useMedicalRequestStore } from '../../stores/useMedicalRequestStore';
  import { router } from '../../router';
  import { computed } from 'vue';
  import { useMergeDataIntoForm } from '../composables/useMergeDataIntoForm';
  import { MpfFormPropsWithConfig } from '../../types/router-meta';
  import { useUrlSegments } from '../composables/useUrlSegments';
  import { useAdminRequestStore } from '../../stores/useAdminRequestStore';
  import { useRequestFormAvailability } from '../composables/useRequestFormAvailability';
  import { RequestType } from '../../types';

  const { formConfig } = useRouteMeta<MpfFormPropsWithConfig>();

  const medicalRequestStore = useMedicalRequestStore();
  const adminRequestStore = useAdminRequestStore();
  const { check } = useRequestFormAvailability();

  const { firstSegment } = useUrlSegments();

  const handleSubmit = async (data: any) => {
    if (!data.valid) return;

    const formStatus = await check(firstSegment.value as RequestType);
    if (!formStatus) return;

    const reporterType = data.values.reporterType;
    if (firstSegment.value === 'medical-request') {
      // NB. starts new here to restart if from PROXY to PATIENT
      medicalRequestStore.startNew();
      medicalRequestStore.setReporterType(reporterType);
    } else if (firstSegment.value === 'admin-request') {
      // NB. starts new here to restart if from PROXY to PATIENT
      adminRequestStore.startNew();
      adminRequestStore.setReporterType(reporterType);
    }
    if (reporterType === 'PATIENT') {
      await router.push(`/${firstSegment.value}/patient-details`);
    } else if (data.values.reporterType === 'PROXY') {
      await router.push(`/${firstSegment.value}/your-details`);
    }
  };

  const { mergeDataIntoForm } = useMergeDataIntoForm();

  const populatedForm = computed<MpfFormPropsWithConfig | null>(() => {
    const config = formConfig.value as MpfFormPropsWithConfig | undefined;
    if (!config) return null;
    // NB. store id must match main route
    return mergeDataIntoForm(config, `${firstSegment.value}`) ?? config;
  });
</script>
